import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import Loader from '../components/Loader';
import LoginPage from '../components/LoginPage';
import { ErrorFlash } from '../components/Flash';
import { useRequest } from '../api/client';

const verify = (token: string) => {
  const [state, _] = useRequest(() => ({
    url: `/users/verify/${token}`,
    method: 'POST',
    body: JSON.stringify({}),
  }));

  return state;
};

interface Props extends RouteComponentProps<any> {}

export default function VerifyUser(props: Props) {
  const state = verify(props.match.params.token);

  if (state.loading) {
    return <Loader />;
  }

  return (
    <LoginPage {...props}>
      <div className="pa4 black-80 ml-auto mr-auto w-70-ns">
        <h3 className="f3 f2-ns lh-title ma0 mb4 black">
          Verifying your Filtru account
        </h3>
        {state.error && <ErrorFlash error={state.error} />}
        {state.loading ? (
          <Loader />
        ) : (
          <p className="black-60 db mv3 lh-copy">
            {state.data
              ? 'All done! Check your inbox for the email with a link to reset your password.'
              : 'An error occurred. Please try again.'}
          </p>
        )}
      </div>
    </LoginPage>
  );
}
